<script>
import { getDefaultThumbnail } from '../../utils/helpers';

export default {
  name: "proof-view-file-thumbnail",
  props: ["file", "activeFileId", "showTitle", "showHorizontal", "isMobile", "disabled", "changeTrackingSummary"],
  methods: {
    selected () {
      this.$emit('selected', this.file);
    },
    getDefaultThumbnail
  },
  computed: {
    // change-tracking summary for this file: keyed by toProofVersionFileId,
    // with a fileName fallback (covers promoted rows / older-version panes)
    changeSummary() {
      const summaries = this.changeTrackingSummary;
      if (!summaries) return null;
      const byId = summaries.byId || {};
      const byName = summaries.byName || {};
      return byId[this.file.id] || byName[(this.file.name || '').toLowerCase()] || null;
    },
    thumbnailFileKey() {
      if (this.file.thumbnailFileKey.startsWith('static')) {
        return '/' + this.file.thumbnailFileKey;
      }
      if (this.file.thumbnailFileKey.startsWith('public/icon/')) {
        return this.file.thumbnailFileKey.replace('public/icon/', '/img/');
      }
      return this.file.thumbnailFileKey;
    }
  }
}
</script>

<template>
    <a @click.prevent="selected" :class="{'d-flex align-items-center' : !showHorizontal}" class="file-sidebar-link gap-3 text-decoration-none px-2 py-2 rounded-3" href="">
      <div class="thumb-icon position-relative">
        <div v-if="!file.viewed" class="active-dot-alt toolbar-active-dot rounded-circle bg-danger position-absolute start-0 top-0 translate-middle"></div>
        <span :style="{background: `url(${file.thumbnailFileKey ? thumbnailFileKey : getDefaultThumbnail(file.docTypeGroup)})`, backgroundSize: 'cover', width: '40px', height: '40px'}"
              :class="activeFileId===file.id && 'active-btn'"
              class="d-inline-flex align-items-center justify-content-center p-2 bg-ashore-white rounded-3 overflow-hidden shadow-base custom-thumbnail">
        </span>
        <span v-if="file.proofFileAnnotations.length>0" class="w-20 h-20 toolbar-edge rounded-circle bg-success-100 text-success-800 position-absolute d-flex align-items-center justify-content-center fs-12">{{file.proofFileAnnotations.length}}</span>
        <!-- change-tracking badge: only the transient analyzing state marks
             thumbnails — results signal through the sidebar and compare rail -->
        <span v-if="changeSummary && changeSummary.state === 'analyzing'"
              v-b-tooltip.hover
              title="Analyzing changes from the previous version…"
              class="w-20 h-20 change-badge change-badge-analyzing rounded-circle position-absolute d-flex align-items-center justify-content-center fs-12"
        >⋯</span>
      </div>
      <span v-cloak v-show="showTitle" v-if="!isMobile" class="text-gray-600 text-nowrap">{{file.name}}</span>
    </a>
</template>

<style scoped>
.custom-thumbnail {
  background-size: contain !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.active-btn{
  box-shadow: 0px 0px 0px 2px #448BE2 !important;
}
.file-sidebar-link:hover{
  background-color: #F4F4F6;
}
.toolbar-edge{
  right: -3.898px;
  bottom: -4px;
}
.change-badge{
  right: -3.898px;
  top: -4px;
}
.change-badge-analyzing{
  background-color: #ebebed;
  color: #6b6b76;
  letter-spacing: 1px;
}
</style>
